import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { PageErrorFallback } from '@/components/ErrorState'

const SentryErrorBoundary = Sentry.ErrorBoundary

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <SentryErrorBoundary fallback={<PageErrorFallback />}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)

// Defer Sentry init until after first paint (bundle-defer-third-party)
setTimeout(() => {
  import('./utils/sentry').then((m) => m.initSentry())
}, 0)
